import classes from './FlexContainer.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children?: ReactNode | ReactNode[]
  variant?: 'row' | 'column'
}

const FlexContainer = ({
  children,
  variant = 'row'
}: Props) => {
  const directionClass = variant === 'row'
    ? classes.row
    : classes.column

  const wrapperClasses = [
    classes.FlexContainer,
    directionClass
  ].filter(wrapperClass => wrapperClass).join(' ')

  return (
    <div className={wrapperClasses}>
      {children}
    </div>
  )
}

export default FlexContainer
